<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                    <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                    </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
              <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
              <b-col cols="12">
                <b-card>
                    <div slot="header" class="mb-0">
                        <b-row>
                            <b-col cols="10">
                                <h3>{{title}}</h3>
                            </b-col>
                        </b-row>
                      </div>
                      <b-row>
                        <b-col cols="12">
                          <base-input :label="language_terms['CODE']" v-model="system_setting.code" :disabled="($route.params.id != '_new')"></base-input>
                        </b-col>
                        <b-col cols="12">
                          <base-input :label="language_terms['JSON_EDITOR']" :disabled="!is_edit">
                              <el-select v-model="system_setting.is_json_value" filterable @change="onChangeSelection">
                                  <el-option v-for="option in json_options"
                                              :key="option.code"
                                              :label="language_terms[option.name]"
                                              :value="option.code">
                                  </el-option>
                              </el-select>
                          </base-input>
                        </b-col>
                        <b-col cols="12" v-if="system_setting.is_json_value == '1'" class="mb-4">
                            <VJsoneditor ref="jsoneditor" v-model="system_setting.value_json" :options="{mode: 'code', onChange: onChange, onError: onError}"></VJsoneditor>
                        </b-col>
                        <b-col cols="12" class="mb-4" v-else>
                          <base-input :label="language_terms['VALUE']">
                            <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" v-model="system_setting.value">
                            </textarea>
                          </base-input>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="12">
                            <base-button @click="save" icon type="primary" class="mr-4" ><i class="fas fa-save mr-2"></i>{{language_terms['SAVE']}}</base-button>
                            <base-button @click="cancel" icon type="danger" ><i class="fas fa-times mr-2"></i>{{language_terms['CANCEL']}}</base-button>

                        </b-col>
                      </b-row>
                </b-card>
              </b-col>
            </b-row>
        </b-container>

    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import VJsoneditor from 'v-jsoneditor'
import { Select, Option } from 'element-ui'

export default
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            is_created: state => state.systemSettings.is_created,
            is_updated: state => state.systemSettings.is_updated,
            system_settings: (state) => state.systemSettings.system_settings,
            system_settings_filter: (state) => state.systemSettings.filter,
            system_setting_data: (state) => state.systemSettings.data
        })
    },
    components:{
        Loading,
        VJsoneditor,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data(){
      return{
        json_options:[
          {code:"1", name :"YES"},
          {code:"0", name :"NO"} 
        ],
        system_setting:{
          code:"",
          value:"",
          value_json:null,
          is_json_value:"0"
        },
        loading:false,
        title:"",
        is_edit:false,
      }
    },
    async mounted()
    {
        let id = this.$route.params.id

        if(id != '_new')
        {
            await this.$store.dispatch("systemSettings/fetch", {code:id});
            this.system_setting = this.system_setting_data
            this.title = this.system_setting.code

            if(this.isJsonString(this.system_setting.value))
            {
              this.system_setting.value_json = JSON.parse(this.system_setting.value)
              this.system_setting.is_json_value = "1"
            }
            else
            {
              this.system_setting.is_json_value = "0"
            }
        }
        else
        {
          this.title = this.language_terms['NEW_SYSTEM_SETTING']
        }
    },
    methods:{
      onChangeSelection()
      {
        console.log(this.system_setting.is_json_value)
        if(this.system_setting.is_json_value == '0')
        {
            this.system_setting.value_json = {}
        }
        else
        {
          this.system_setting.value = null
        }
      },
      cancel()
      {
        this.$router.push("/settings/system-settings")
      },
      async save()
      {
           this.loading = true
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("systemSettings/create", this.system_setting);
                if(this.is_created)
                {
                    this.$router.push("/settings/system-settings")
                }
            }
            else
            {
                await this.$store.dispatch("systemSettings/update", this.system_setting);
                if(this.is_updated)
                {
                    this.$router.push("/settings/system-settings")
                }
            }

            this.loading = false
      },
      onChange() {
        console.log("change");
      },
      onError()
      {
        console.log('error')
      },
      isJsonString(str) 
      {
          try {
              JSON.parse(str);
          } catch (e) {
              return false;
          }
          return true;
      }
    }
}
</script>
